export default __webpack_public_path__ + "static/dont-decorative-only-9842bb89ab59368911cad248f094a21a.png";